import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { useMeasuredHeaderPart } from 'layout/HeaderOffsets';
import { ReactComponent as WifiOffIcon } from 'assets/icons/connectivity/wifi-off.svg';
import { ReactComponent as RefreshIcon } from 'assets/icons/connectivity/refresh.svg';
import { ReactComponent as CheckIcon } from 'assets/icons/connectivity/check-circle.svg';
import { ReactComponent as ClockIcon } from 'assets/icons/connectivity/clock.svg';

import { BANNER_COPY, BANNER_VARIANT } from '../../constants';
import { selectBannerVariant } from '../../state/selectors';

import styles from './ConnectionBanner.module.css';

const ICONS = {
    [BANNER_VARIANT.OFFLINE]: WifiOffIcon,
    [BANNER_VARIANT.RECONNECTING]: RefreshIcon,
    [BANNER_VARIANT.BACK_ONLINE]: CheckIcon,
    [BANNER_VARIANT.SLOW]: ClockIcon,
};

function ConnectionBanner() {
    const variant = useSelector(selectBannerVariant);
    const measureRef = useMeasuredHeaderPart('banner');

    const copy = variant ? BANNER_COPY[variant] : null;
    const Icon = variant ? ICONS[variant] : null;

    return (
        <div
            ref={measureRef}
            className={styles.region}
            role="status"
            aria-live="polite"
            aria-atomic="true"
        >
            {copy && (
                <div className={cn(styles.banner, styles[variant])}>
                    <div className={styles.content}>
                        <Icon
                            width={20}
                            height={20}
                            className={styles.icon}
                            aria-hidden="true"
                            focusable="false"
                        />
                        <div className={styles.text}>
                            <p className={styles.title}>{copy.title}</p>
                            <p className={styles.body}>{copy.body}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ConnectionBanner;
